// extracted by mini-css-extract-plugin
module.exports = {"Slider":"Slider_Slider__oIZtG","Slider_wrapper":"Slider_Slider_wrapper__GTsDm","Slider_slide":"Slider_Slider_slide__xDcTP"};